import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Box,
  Typography,
  Divider,
  FormHelperText,
} from "@mui/material";

const BMXMultiListSelect = ({
  input,
  meta,
  label,
  options = [],
  disabled,
  maxHeight,
  slotProps = {},
}) => {
  const MAX_HEIGHT = maxHeight || 220;
  const isError = meta?.touched && (meta?.error || meta?.submitError);
  const selectedValues = input.value || [];

  const isSelected = (value) => selectedValues.some((el) => el.value === value);

  const { inputLabel = {} } = slotProps;

  const handleAdd = (event) => {
    const option = event.target.value;
    if (!isSelected(option.value)) {
      input.onChange([...selectedValues, option]);
    }
  };

  const handleRemove = (valueToRemove) => {
    input.onChange(selectedValues.filter((el) => el.value !== valueToRemove));
  };

  return (
    <FormControl
      variant="standard"
      fullWidth
      error={!!isError}
      disabled={disabled}
    >
      <InputLabel sx={inputLabel}>{label}</InputLabel>

      <Select
        value=""
        onChange={handleAdd}
        renderValue={() => ""}
        MenuProps={{
          PaperProps: { style: { maxHeight: 240 } },
        }}
      >
        {options.map((option) => {
          const selected = isSelected(option.value);

          return (
            <MenuItem key={option.value} value={option} disabled={selected}>
              <ListItemText primary={option.label} />
            </MenuItem>
          );
        })}
      </Select>

      <Box
        sx={{
          position: "absolute",
          top: "100%",
          left: 0,
          right: 0,
          mt: 1,
          maxHeight: MAX_HEIGHT,
          overflowY: "auto",
          backgroundColor: "transparent",
          zIndex: 10,
        }}
      >
        {selectedValues.map((item) => (
          <Box
            key={item.value}
            onClick={() => handleRemove(item.value)}
            sx={{
              px: 0.5,
              py: 1,
              cursor: "pointer",
              borderBottom: "1px solid #cfd8dc",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            <Typography sx={{ fontWeight: 600, fontSize: "0.9rem" }}>
              {item.label}
            </Typography>
          </Box>
        ))}
      </Box>

      {isError && (
        <FormHelperText>{meta.error || meta.submitError}</FormHelperText>
      )}
    </FormControl>
  );
};

export default BMXMultiListSelect;
